import { mapGetters, mapState } from 'vuex'
import { initRotateLabel } from '@/plugins/rotated-label.plugin'
import { initializeDroneImageOverlay } from '@/plugins/drone-image-overlay.plugin'
import initDeleteMenu from '@/plugins/gmap-delete-menu.plugin'

export default {
    data() {
      return {
        rotatedLabel: null,
        droneOverlay: null,
        deleteMenu: null,
        infoWindow: null
      }
    },

    computed: {  
      ...mapGetters({
        'map': 'gmap/map',
        'drawingManager': 'gmap/drawingManager',
        'allShapes': 'gmap/allShapes'
      })
    },

    methods: {
      initDrawingManager(){
        let drawingManager = new google.maps.drawing.DrawingManager({
          editable: true,
          drawingControl: false,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: []
          },
          markerOptions: {
            draggable: true
          },

          polylineOptions: {
            clickable: true,
            editable: true,
            // draggable: true,
            geodesic: true
          },

          polygonOptions: {
            clickable: true,
            editable: true,
            // draggable: true,
            geodesic: true,
            fillOpacity: 0.0
          },

          rectangleOptions: {
            clickable: true,
            editable: true,
            // draggable: true,
            geodesic: true
          },

          circleOptions: {
            clickable: true,
            editable: true,
            // draggable: true,
            geodesic: true
          }

        });
        
        this.$store.dispatch('gmap/setDrawingManager', drawingManager)
        this.drawingManager.setMap(this.map);
        if(typeof(this.afterDrawingInit) == 'function'){
          this.afterDrawingInit(drawingManager)
        }

        this.rotatedLabel = initRotateLabel()
        this.droneOverlay = initializeDroneImageOverlay()
        this.deleteMenu = initDeleteMenu()
        this.infoWindow = new google.maps.InfoWindow({
                            ariaLabel: "Uluru",
                          });
        const that = this
        google.maps.Polyline.prototype.resetEquipmentIcon = function(vm=that) { 
          vm.resetEquipmentIconFromInstance(this)
        }

        google.maps.Polygon.prototype.resetEquipmentIcon = function(vm=that) { 
          vm.resetEquipmentIconFromInstance(this) 
        }
      },

      resetEquipmentIconFromInstance(obj) {
        this.resetEquipmentIcon(obj)
      },

      getNormalizedCoord(coord, zoom) {
        var y = coord.y;
        var x = coord.x;

        // tile range in one direction range is dependent on zoom level
        // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
        var tileRange = 1 << zoom;

        // don't repeat across y-axis (vertically)
        if (y < 0 || y >= tileRange) {
          return null;
        }

        // repeat across x-axis
        if (x < 0 || x >= tileRange) {
          x = (x % tileRange + tileRange) % tileRange;
        }

        return {x: x, y: y};
      },

      initOrthoMap(){
        if(this.orthoImage.status != 'Completed'){
          return
        }

        const bounds = this.orthoImage.tile_bounds;
        let vm = this
        const host = (new URL(this.orthoImage.original_url)).origin
        const tileMapType = new google.maps.ImageMapType({
          getTileUrl: function(coord, zoom) {
            const prefix_url = vm.orthoImage.prefix_url_for_tile;
            const normalizedCoord = vm.getNormalizedCoord(coord, zoom);
            if (!normalizedCoord || zoom < 15) {
              return null;
            }

            const bound = Math.pow(2, zoom);
            const y = (bound - normalizedCoord.y - 1)
            if(normalizedCoord.x < bounds[zoom][0][0] || normalizedCoord.x > bounds[zoom][0][1] || y < bounds[zoom][1][0] || y > bounds[zoom][1][1]){
              // if(zoom > 21){
              //   tileWidth=256;
              //   tileHeight=256;
              //   diff = (Math.pow(2,zoom) - 1) / (Math.pow(2,21) - 1)
              //   coord.x = Math.ceil(coord.x /diff)
              //   coord.y = Math.ceil(coord.y / diff)
              //   var normalizedCoord = getNormalizedCoord(coord, 21);
              //   zoom = 21
              // }
              // return `https://khms0.googleapis.com/kh?v=908&hl=en-IN&x=${normalizedCoord.x}&y=${normalizedCoord.y}&z=${zoom}`;
              return
            }
            return host + prefix_url +
                '/' + zoom + '/' + normalizedCoord.x + '/' +
                y + '.png';
          },
          tileSize: new google.maps.Size(256, 256),
          maxZoom: 25,
          minZoom: 15,
          name: "ortho",
          streetViewControl: true
        });

        this.map.addListener('zoom_changed', function() {
          if(this.getZoom() > 18){
            this.setMapTypeId('ortho');
          }
          else{
            this.setMapTypeId(google.maps.MapTypeId.SATELLITE);
          }
        });

        this.map.addListener('click', function(e, mainObj=vm) {
          if(mainObj.$store.getters['sections/copyData'].enabled){
            if(mainObj.$store.getters['sections/copyData'].initiateCopy){
              mainObj.$store.getters['sections/copyData'].initiateCopy(e.latLng)
            }
          }
        });
        // this.map.setMapTypeId('ortho');
        this.map.mapTypes.set('ortho', tileMapType);
        this.map.overlayMapTypes.push(tileMapType);
      },

      getPolygonCenter(coords) {
          let latSum = 0, lngSum = 0;
          coords.forEach(coord => {
              latSum += coord.lat;
              lngSum += coord.lng;
          });
          return {
              lat: latSum / coords.length,
              lng: lngSum / coords.length
          };
        },

      copyPolygon(center) {
          

          // const section = this.$store.getters['sections/copyData'].section
          // const polygonCoords = section.coords
          // const originalCenter = this.getPolygonCenter(polygonCoords);
          // const newPolygonCoords = polygonCoords.map(coord => {
          //     return {
          //         lat: center.lat() + (coord.lat - originalCenter.lat),
          //         lng: center.lng() + (coord.lng - originalCenter.lng)
          //     };
          // });

          // section.coords = newPolygonCoords

          // const newPolygon = new google.maps.Polygon({
          //     paths: newPolygonCoords,
          //     strokeColor: "#FF0000",
          //     strokeOpacity: 0.8,
          //     strokeWeight: 2,
          //     fillColor: "#FF0000",
          //     fillOpacity: 0.35,
          // });
          // newPolygon.setMap(this.map);
      },

      setupCreateCallbacks({onPolygonComplete, onPolylineComplete, onCircleComplete, onOverlayComplete}){
        if(typeof(onPolylineComplete) == 'function'){
          google.maps.event.addListener(this.drawingManager, 'polylinecomplete', onPolylineComplete);
        }

        if(typeof(onPolygonComplete) == 'function'){
          google.maps.event.addListener(this.drawingManager, 'polygoncomplete', onPolygonComplete)
        }

        if(typeof(onCircleComplete) == 'function'){
          google.maps.event.addListener(this.drawingManager, 'circlecomplete', onCircleComplete)
        }

        if(typeof(onOverlayComplete) == 'function'){
          google.maps.event.addListener(this.drawingManager, 'overlaycomplete', onOverlayComplete)
        }
      },

      computeLength(gCoords){
        return google.maps.geometry.spherical.computeLength(gCoords)
      },

      computeArea(gCoords){
        return google.maps.geometry.spherical.computeArea(gCoords)
      },

      computeCircleArea(shape){

      },

      computeCircleCircumference(shape){

      },

      setShapeLabels(shape){
        let vm = this
        let arr = []
        if(shape instanceof google.maps.Rectangle){
          var data = getRectangleBoundsArray(shape)
          arr.push(data.ne, data.nw, data.sw, data.se)
        }
        else{
          arr = shape.getPath().getArray().slice(0)
        }
        if((shape instanceof google.maps.Polygon) || (shape instanceof google.maps.Rectangle)){
          arr.push(arr[0])
        }
        let lengthMarkers = []

        arr.forEach(function(ar,i){
          if(i > 0){
            var midval = null
            const lat = (arr[i].lat() + arr[i-1].lat())/2
            const lng = (arr[i].lng() + arr[i-1].lng())/2

            var line_overlay = new google.maps.Polyline({
              path: [arr[i-1], arr[i]],
              clickable: true
            });
            let length = vm.computeLength(line_overlay.getPath().getArray())
            var heading = google.maps.geometry.spherical.computeHeading(arr[i], arr[i-1])
            var angle = heading
            if(heading < 0){
              heading = heading + 90
            }
            else{
              heading = heading - 90
            }

            var margin = 0
            if((angle >= -180 && angle < -90) || (angle >=0 && angle < 90)){
              margin = 15
            }

            if((angle > 90 && angle <=180) || (angle > -90 && angle < 0)){
              margin = -15
            }

            if(length > 0){
              
              length = `${length.toFixed(2)} m`
              
              const label = new vm.rotatedLabel(
                new google.maps.LatLng(lat, lng),
                length,
                (heading),
                vm.map,
                {
                  color: "white",
                  fontSize: "12px",
                  zIndex: "99999",
                  marginLeft: `${margin}px`,
                  // marginRight: "15px",
                }
              );
              label.setMap(null)
              lengthMarkers.push(label)
            }
          }
        })
        shape.setOptions({lengthMarkers: lengthMarkers})
      },

      addPolygon({ coords, id, strokeColor='black', fillOpacity, centerCoords, editable=false, label, sectionType, equipmentId, zIndex }){
        let obj = new google.maps.Polygon({
          path: coords,
          clickable: true,
          editable: editable,
          // draggable: true,
          geodesic: true,
          id: id,
          drawingType: 'polygon',
          sectionType: sectionType,
          strokeColor: strokeColor,
          fillOpacity: 0.0,
          map: this.map,
          equipmentId: equipmentId,
          zIndex: zIndex
        });
        let centerMarker
        if(equipmentId){
          centerMarker = this.setEquipmentIcon(obj, obj.getBoundingBox().getCenter(), equipmentId, label)
        } else {
          centerMarker = this.addMarker({
            position: obj.getBoundingBox().getCenter(),
            label: label,
            draggable: false,
            id: id,
            sectionType: sectionType,
            equipmentId: equipmentId
          })
        }
        centerMarker.setOptions({shape: obj, id: id})
        obj.setOptions({centerMarker: centerMarker})
        this.initUpdateCallbacks(obj)
        this.setShapeLabels(obj)
        return obj
      },

      addPolyline({ coords, id, strokeColor='black', fillOpacity, centerCoords, editable=false, label, sectionType, equipmentId, zIndex }){
        let obj = new google.maps.Polyline({
          path: coords,
          clickable: true,
          editable: editable,
          // draggable: true,
          geodesic: true,
          id: id,
          drawingType: 'polyline',
          sectionType: sectionType,
          strokeColor: strokeColor,
          fillOpacity: 0.0,
          map: this.map,
          equipmentId: equipmentId,
          zIndex: zIndex
        });

        let centerMarker
        if(equipmentId){
          centerMarker = this.setEquipmentIcon(obj, obj.getBoundingBox().getCenter(), equipmentId, label)
        } else {
          centerMarker = this.addMarker({
            position: obj.getBoundingBox().getCenter(),
            label: label,
            draggable: false,
            id: id,
            sectionType: sectionType,
            equipmentId: equipmentId
          })
        }

        obj.setOptions({ centerMarker: centerMarker })
        centerMarker.setOptions({shape: obj, id: id})
        this.initUpdateCallbacks(obj)
        this.setShapeLabels(obj)
        return obj
      },

      addMarker({position, label, icon, id, sectionType, equipmentId, zIndex}){
        let obj = new google.maps.Marker({
            position: position,
            label: label,
            map: this.map,
            sectionType: sectionType,
            id: id,
            equipmentId: equipmentId,
            zIndex: zIndex
          })
        if(equipmentId){
          obj.setOptions({ icon: this.equipmentIcon(equipmentId), id: id })
        } else if(sectionType == 'note'){
          obj.setOptions({ icon: this.noteIcon(), id: id })
        } else {
          obj.setOptions({ icon: this.roofIcon(), id: id })
        }
        if(sectionType == 'note'){
          this.initNoteCallbacks(obj)
        } else {
          this.initUpdateCallbacks(obj)
        }
        return obj
      },

      resetDraggable(){
        this.$store.dispatch('gmap/resetDraggable')
      },

      initNoteCallbacks(marker){
        marker.vm = this
        google.maps.event.addListener(marker, "mouseover", function(marker){
          if(this.message){
            this.vm.infoWindow.setContent(`<p>${this.message} </p>`)
            this.vm.infoWindow.open({
              anchor: this,
              map: this.map
            })
          }
        });

        google.maps.event.addListener(marker, "click", function(marker){
          this.vm.onNoteMarkerClick(this)
        });
      },

      initUpdateCallbacks(shape, excludedEvents=[]){
        shape.vm = this
        if(!excludedEvents.includes('dragend')){
          google.maps.event.addListener(shape, "dragend", function(line, obj=shape){
            console.log("EVENT >>> dragend")
            obj.setOptions({dragging: false})
            if(shape instanceof google.maps.Marker){
              obj.vm.onMarkerChange(obj)
            } else {
              if(obj.useSectionFromShape){
                obj.vm.onPolyChangeWithoutSectionInstance(obj, 'drag')
              } else {
                obj.vm.onPolyChange(obj, 'drag')
              }
            }
            if(obj.updateEvent){
              obj.setOptions({updateEvent: false})
              obj.vm.initUpdateCallbacks(shape, ['dragend', 'click', 'dragstart'])
            }
            obj.vm.resetLabels(obj)
          });
        }

        if(!excludedEvents.includes('dragstart')){
          google.maps.event.addListener(shape, "dragstart", function(line, obj=shape){
            console.log("EVENT >>> dragstart")
            obj.setOptions({dragging: true})
            obj.vm.hideLabels()
          });
        }

        if(!excludedEvents.includes('click')){
          google.maps.event.addListener(shape, "click", function(line){
            if(this.vm.$store.getters['sections/copyData'].enabled){
              google.maps.event.trigger(this.vm.map, 'click', line)
            } else {
              event.stopPropagation()
              if(event.shiftKey && line.vertex > -1){
                let arr = shape.getPath().getArray()
                if(arr.length > 4){
                  let vm = shape.vm
                  shape.getPath().removeAt(line.vertex)
                  shape.setOptions({updateEvent: true, vm: vm})
                  google.maps.event.trigger(shape, 'dragend', shape);
                  return
                } else {
                  //Add an alert message here
                }
                return
              }
              this.vm.resetDraggable()
              this.vm.onShapeClick(this)
            }
          });
        }
        if(shape instanceof google.maps.Circle){
          google.maps.event.addListener(shape, "radius_changed", function(line){
            
          });
          google.maps.event.addListener(shape, "center_changed", function(line){
            
          });
        } else if(shape instanceof google.maps.Rectangle){
          google.maps.event.addListener(shape, "bounds_changed", function(line){
            
          });
        } else{
          if(shape instanceof google.maps.Marker){
            return
          }
          google.maps.event.addListener(shape.getPath(), "insert_at", function(line, obj=shape){
            obj.vm.onPolyChange(obj)
          });
          google.maps.event.addListener(shape.getPath(), "remove_at", function(line, obj=shape){
            // obj.vm.onPolyChange(obj)
          });
          google.maps.event.addListener(shape.getPath(), "set_at", function(x, y, obj=shape){
            if(obj.dragging){
              return
            }
            obj.vm.onPolyChange(obj)
          });

          google.maps.event.addListener(shape, "contextmenu", (e) => {
            // Check if click was on a vertex control point
            if (e.vertex == undefined) {
              return;
            }

            shape.vm.deleteMenu.open(shape.vm.map, shape, shape.getPath(), e.vertex, {onDelete: shape.vm.deleteVertex});
          });
        }
      },

      equipmentIcon(equipmentId){
        const equipment = this.equipments.filter(e => e.id == parseInt(equipmentId))[0]
        return {
          url: require('@/assets/equipment_icons/' + equipment.icon),
          scaledSize: new google.maps.Size(17.5, 17.5),
          anchor: new google.maps.Point(10,10),
          labelOrigin:  new google.maps.Point(8.5,20)
        }
      },

      noteIcon(){
        return {
          url: require('@/assets/note-icon.png'),
          scaledSize: new google.maps.Size(17.5, 17.5),
          anchor: new google.maps.Point(10,10),
          labelOrigin:  new google.maps.Point(8.5,20)
        }
      },

      roofIcon(){
        return {
          url: require('@/assets/hexagon-red.png'),
          scaledSize: new google.maps.Size(20, 20),
          anchor: new google.maps.Point(10,10),
          labelOrigin:  new google.maps.Point(10,10)
        }
      },

      autoSetCoords(shape, event=null, section=null){
        if(event == 'drag'){
          return
        }

        let coords_arr = shape.getPath().getArray()
        if((coords_arr.length < 3 || coords_arr.length > 4) || !shape.equipmentId){
          return
        }
        let dist = google.maps.geometry.spherical.computeDistanceBetween(coords_arr[0], coords_arr[1]);
        let heading = google.maps.geometry.spherical.computeHeading(coords_arr[0], coords_arr[1]);
        let heading2 = heading
        let lat1 = coords_arr[0].lat()
        let lat2 = coords_arr[1].lat()
        let lng1 = coords_arr[0].lng()
        let lng2 = coords_arr[1].lng()
        let lat3 = coords_arr[2].lat()
        let lng3 = coords_arr[2].lng()
        let deltaLat = lat2 - lat1
        let deltaLng = lng2 - lng1

        let deltaLat2 = lat3 - lat2
        let deltaLng2 = lng3 - lng2

        let dir = null

        if(deltaLat >= 0 && deltaLng >= 0){
          dir = "ne"
        }else if(deltaLat >= 0 && deltaLng <= 0){
          dir = "nw"
        } else if(deltaLat <= 0 && deltaLng <= 0){
          dir = "sw"
        } else if(deltaLat <= 0 && deltaLng >= 0){
          dir = "se"
        }

        if(deltaLat2 >= 0 && deltaLng2 >= 0){
          console.log("ne")
          heading2 = heading2 - 90
        }else if(deltaLat2 >= 0 && deltaLng2 <= 0){
          heading2 = heading2 + 90
          console.log("nw")
        } else if(deltaLat2 <= 0 && deltaLng2 <= 0){
          heading2 = heading2 + 90
          console.log("sw")
        } else if(deltaLat2 <= 0 && deltaLng2 >= 0){
          heading2 = heading2 + 90
          console.log("se")
        }

        console.log(heading)
        console.log(heading2)
        if(dir == "ne"){
          if(heading > 0){
            dist = dist * -1
          }
        } else if(dir == "se"){
          if(heading > 0){
            dist = dist * -1
          }
        } else if(dir == "sw"){
          if(heading < 0 ){
            dist = dist * -1
          }
        } else if(dir =="nw"){
          if(heading  < 0 ){
            dist = dist * -1
          }
        }

        let newCoord = google.maps.geometry.spherical.computeOffset(coords_arr[2], dist, heading);

        let reAddListners = false
        if(coords_arr[3]){
          reAddListners = true
        }
        coords_arr[3] = newCoord
        shape.setPath(coords_arr)
        let firstLength = google.maps.geometry.spherical.computeDistanceBetween(coords_arr[0], coords_arr[1]);
        let secondLength = google.maps.geometry.spherical.computeDistanceBetween(coords_arr[1], coords_arr[2]);
        
        let length, width
        const equipmentData = section ? section.equipment_detail.data : this.section.equipment_detail.data;
        if(equipmentData.lockedFromInput){
          length = equipmentData.length
          width = equipmentData.width
        } else {
          length = firstLength > secondLength ? firstLength : secondLength
          width = firstLength > secondLength ? secondLength : firstLength
          length = Math.round(length*100)
          width = Math.round(width*100)
        }
        if(section){
          section.coords = coords_arr

          section.equipment_detail.data = {
            ...section.equipment_detail.data, 
            ...{
              length: length,
              width: width
            }
          }
        } else {
          this.section.coords = coords_arr
          
          this.section.equipment_detail.data = {
            ...this.section.equipment_detail.data, 
            ...{
              length: length,
              width: width
            }
          }
        }
        
        shape.setOptions({
          length: firstLength,
          width: secondLength
        })

        if(reAddListners){
          this.initUpdateCallbacks(shape, ['dragend', 'click', 'dragstart'])
          shape.setOptions({
            editable: false
          })
          shape.setOptions({
            editable: true
          })
        }
      },

      resetEquipmentIcon(shape){
        const position = shape.getBoundingBox().getCenter()
        const section = this.sectionList.filter(s => parseInt(s.id) == parseInt(shape.id))[0]
        const label = section.label
        const equipmentId = shape.equipmentId
        // shape.centerMarker.setOptions({
        //   bounds_: overlayData.bounds,
        //   image_: overlayData.imgSrc,
        //   map_: overlayData.map,
        //   imageCoordinates: overlayData.coords,
        //   rotation: overlayData.rotation,
        //   upperLeft: overlayData.upperLeft,
        //   label: overlayData.label
        // })
        // shape.centerMarker.draw()
        shape.centerMarker.setMap(null)
        let centerMarker = this.setEquipmentIcon(shape, position, equipmentId, label)
        centerMarker.setOptions({shape: shape, id: section.id})
        shape.setOptions({centerMarker: centerMarker})
      },

      setEquipmentIcon(shape, position, equipmentId, label){
        const overlayData = this.equipmentOverlayData(shape, position, equipmentId, label)

        var imageOverlay = new this.droneOverlay(
          overlayData.bounds, 
          overlayData.imgSrc, 
          this.map, 
          overlayData.coords, 
          overlayData.rotation, 
          overlayData.top_left, 
          overlayData.label
        )
        imageOverlay.setOptions({shape: shape, equipmentId: equipmentId})
        let vm = this
        imageOverlay.onClick = (overlay) => {
          vm.onShapeClick(overlay)
        }
        // debugger
        // imageOverlay.draw()
        // var marker = new google.maps.Marker({
        //   map: map,
        //   position: position,
        //   icon: equipmentIcon,
        //   draggable: false,
        //   zIndex: 99999,
        // });

        // marker.addListener('click', function() {
        //   showSelectedEquipment(this.equipmentUid)
        // })

        return imageOverlay
      },

      equipmentOverlayData(shape, position, equipmentId, label){
        var equipmentIcon = this.equipmentIcon(equipmentId)
        var rotation = 0;
        var pointDist = 0.000002
        if(shape instanceof google.maps.Polygon){
          var coords = shape.getPath().getArray()
          var coords_x = coords[0], coords_y = coords[1]
          if(coords_x && coords_y ){
            var dist1 = google.maps.geometry.spherical.computeDistanceBetween(coords_x, coords_y);
          }

          if(coords[1] && coords[2]){
            var dist2 = google.maps.geometry.spherical.computeDistanceBetween(coords[1], coords[2]);
          }
          if(dist2 > dist1){
            coords_x = coords[1] 
            coords_y = coords[2]
          }
          if(coords_x && coords_y){
            var x1=coords_x.lat(),y1=coords_x.lng(), x2=coords_y.lat(), y2=coords_y.lng()
            var mid_x = (x1 + x2)/2 ,  mid_y = (y1+y2)/2
            var center_x = (typeof(position.lat) == 'function' ? position.lat() : position.lat), center_y = (typeof(position.lng) == 'function' ? position.lng() : position.lng)
            pointDist = (Math.sqrt(Math.pow((center_x - mid_x), 2) + Math.pow((center_y - mid_y), 2)))/4
            rotation = google.maps.geometry.spherical.computeHeading(coords_x, coords_y);
            rotation = rotation - 90
          }
        }
        var coords = this.getPolygonFromCoord(position, pointDist)
        var bounds = new google.maps.LatLngBounds(
              new google.maps.LatLng(coords[0].lat, coords[0].lng), 
              new google.maps.LatLng(coords[2].lat, coords[2].lng)
            );
        var top_left = new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getSouthWest().lng())
        var imgSrc = equipmentIcon.url

        return {
          bounds: bounds, 
          imgSrc: imgSrc, 
          map: this.map,
          coords: coords, 
          rotation: rotation,
          top_left: top_left, 
          label: label
        }
      },

      getPolygonFromCoord(position, val=0.00003){
        if(typeof(position.lat) != 'function'){
          position = new google.maps.LatLng(position.lat, position.lng)
        }
        const tl = { lat: position.lat()-val, lng: position.lng()-val }
        const tr = { lat: position.lat()+val, lng: position.lng()-val }
        const bl = { lat: position.lat()-val, lng: position.lng()+val }
        const br = { lat: position.lat()+val, lng: position.lng()+val }
        return [tl, tr, br, bl]
      },

      resetCenterMarker(shape){
        const center = shape.getBoundingBox().getCenter()
        if(shape.centerMarker){
          shape.centerMarker.setOptions({position: center})
        }
      },

      deleteVertex(shape, vertex){
        let arr = shape.getPath().getArray()
        if(arr.length > 3){
          let vm = shape.vm
          shape.getPath().removeAt(vertex)
          shape.setOptions({updateEvent: true, vm: vm})
          google.maps.event.trigger(shape, 'dragend', shape);
          return
        } else {
          alert('Polygon should have atleast 3 vertex')
        }
      }
    },
}
